

import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { ChevronDown, ChevronUp, Eye, Edit, Trash2, UserCheck, MoreHorizontal, Search, ArrowLeft, ChevronLeft, ChevronRight, UserPlus, Link, QrCode, Plus, User, CheckCircle, Building, Briefcase, Award, Languages, GraduationCap, CreditCard, Baby, MapPin, Phone, Mail, Upload, Check } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Card, CardContent } from '../../components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../components/ui/dialog';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../components/ui/dropdown-menu';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../components/ui/tooltip';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../../components/ui/alert-dialog';
import { ScrollArea } from '../../components/ui/scroll-area';
import { Textarea } from '../../components/ui/textarea';
import { Input } from '../../components/ui/input';
import { cn } from '../../components/lib/utils'; 
import { motion, useAnimation } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select"
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../../components/ui/command";

import { getAllCandidates, getCandidateApplications, getJobCategoriesList, getTalentPoolCandidateById, gettalentPoolCandidates, MarkCandidateStatus } from '../../services/candidateapi';
import { toast } from 'react-hot-toast';
import QRCode from "qrcode";
import { UserType } from "../../components/types/application.types";
import { useRbac } from '../../context';
import { getJobs, updatePublicJobApplication } from '../../services/jobsapi';
import { bulkUploadTalentPoolCandidates, ICreateCandidateRequestBody, updateTalentPoolApplications } from '../../services/talentpool';
import { getMySubordinates } from '../../services/usersapi';
import { X } from "lucide-react";
import * as XLSX from 'xlsx';
interface Candidate {
  id: string;
  name: string;
  email: string;
  phone: string;
  highestQualification: string;
  totalExperienceYears: number;
  totalExperienceMonths: number;
  skills: string[];
  knownTools?: string[];
  currentLocationDetails: {
    city: string;
    fullAddress: string;
  };
  profileSource: string;
  createdAt: string;
  profileCreatedAt: string;
  candidateProfileStrength: number;
  availabilityStatus: string;
  sourcedBy: {
    id: string;
    name: string;
    email: string;
  };
  fatherName?: string;
  gender?: string;
  dateOfBirth?: string;
  aadharNumber?: string;
  spokenLanguages?: string[];
  preferredJobCategories?: string[];
  preferredEmploymentTypes?: string[];
  resumeUrl?: string;
  status? : string;
}

interface GetCandidateApplicationApp {
  applicationId: string;
  job: {
    id: string;
    title: string;
    companyName: string;
  };
  appliedOn: string;
  currentStatus: {
    status: string;
    timestamp: string;
    updatedBy: {
      id: string;
      username: string;
      email: string;
    };
  };
  sourcedBy: {
    id: string;
    username: string;
    email: string;
  };
}

interface CandidatesTableProps {
  candidates: Candidate[];
  setCandidates: (candidates: Candidate[]) => void;
  onCandidateSelect: (candidate: Candidate) => void;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  onSort: (column: string) => void;
  onStatusChange: (candidate: Candidate, newStatus: string, comment?: string) => void;
  candidatesLoading: boolean;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onAddCandidate?: () => void;
  user?: UserType | null;
  pagination: any;
  selectedDateFrom: string;
  setSelectedDateFrom: (date: string) => void;
  selectedDateTo: string;
  setSelectedDateTo: (date: string) => void;
  category: string;
  setCategory: (category: string) => void;
  sourcedBy: string;
  setSourcedBy: (sourcedBy: string) => void;
  sourcedByOptions: Array<{ id: string; name: string; email?: string }>;
  applicationsStatus: string;
  setApplicationsStatus: (status: string) => void;
  // Bulk upload props
  showBulkUploadModal: boolean;
  setShowBulkUploadModal: (show: boolean) => void;
  handleBulkUpload: () => void;
  handleFileUpload: (file: File) => void;
  uploadedFile: File | null;
  setUploadedFile: (file: File | null) => void;
  // Drag and drop props
  isDragOver: boolean;
  setIsDragOver: (value: boolean) => void;
  handleDragOver: (e: React.DragEvent) => void;
  handleDragLeave: (e: React.DragEvent) => void;
  handleDrop: (e: React.DragEvent) => void;
}

const CandidatesTable: React.FC<CandidatesTableProps> = ({
  candidates,
  setCandidates,
  onCandidateSelect,
  sortBy,
  sortOrder,
  onSort,
  onStatusChange,
  candidatesLoading,
  currentPage,
  totalPages,
  onPageChange,
  searchTerm,
  setSearchTerm,
  onAddCandidate,
  user,
  pagination,
  selectedDateFrom,
  setSelectedDateFrom,
  selectedDateTo,
  setSelectedDateTo,
  category,
  setCategory,
  sourcedBy,
  setSourcedBy,
  sourcedByOptions,
  applicationsStatus,
  setApplicationsStatus,
  // Bulk upload props
  showBulkUploadModal,
  setShowBulkUploadModal,
  handleBulkUpload,
  handleFileUpload,
  uploadedFile,
  setUploadedFile,
  isDragOver,
  setIsDragOver,
  handleDragOver,
  handleDragLeave,
  handleDrop,
}) => {
  const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [openSourcedByDropdown, setOpenSourcedByDropdown] = useState(false);
  const [selectedCandidateApplications, setSelectedCandidateApplications] = useState<GetCandidateApplicationApp[]>([]);
  const [selectedCandidateName, setSelectedCandidateName] = useState('');
  const [selectedCandidateId, setSelectedCandidateId] = useState<string | null>(null);
  const [newStatus, setNewStatus] = useState<string | null>(null);
  const [comment, setComment] = useState('');
  const [isCommentDialogOpen, setIsCommentDialogOpen] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [actionCandidate, setActionCandidate] = useState<Candidate | null>(null);
  const [progress, setProgress] = useState(0);
  const controls = useAnimation();
  const [showQRModal, setShowQRModal] = useState(false);
  const [qrCodeDataURL, setQrCodeDataURL] = useState("");
  const [showCandidateDetailsModal, setShowCandidateDetailsModal] = useState(false);
  const [selectedCandidateForDetails, setSelectedCandidateForDetails] = useState<Candidate | null>(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [openJobSelectionModal,setOpenJobSelectionModal] = useState(false)
  const [loadingModal,setLoadingModal] = useState(false)
  const [assignedJobs, setAssignedJobs] =  useState<any[]>([]);
  const [jobSearchValue,setJobSearchValue] = useState("")
  const [selectedJobId,setSelectedJobId] = useState("")
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(null);
  const [selectedCandidateForShortList,setSelectedCandidateForShortList] = useState({})
 const [categoryOptions, setCategoryOptions] = useState<any[]>([]);
  const DURATION = 1;

  const getCandidateTools = (candidate: Candidate | null | undefined): string[] => {
    if (!candidate) return [];
    const toolsFromKnownTools = Array.isArray(candidate.knownTools) ? candidate.knownTools : [];
    const toolsFromLegacyKey = Array.isArray((candidate as any).tools) ? (candidate as any).tools : [];
    return toolsFromKnownTools.length ? toolsFromKnownTools : toolsFromLegacyKey;
  };

  

  useEffect(() => {
    const fetchCategoryOptions = async () => {
      const response = await getJobCategoriesList();
      setCategoryOptions(response.data);
    }
    fetchCategoryOptions();
  }, []);


  useEffect(() => {
    if (isDialogOpen && actionCandidate?.id) {
      console.log(`Opening application history for candidate: ${actionCandidate.name}`);
      setProgress(0);
      const target = selectedCandidateApplications.length ?? 0;
      let start = 0;
      const step = () => {
        start += 1;
        setProgress(start);
        if (start < target) {
          setTimeout(step, (DURATION * 1000) / target);
        }
      };
      if (target > 0) {
        step();
      }
    } else {
      setProgress(0);
    }
  }, [isDialogOpen, actionCandidate, selectedCandidateApplications]);

  useEffect(() => {
    controls.start('visible');
  }, [controls]);

  useEffect(() => {
    async function getAlljobs() {
      const jobs = await getJobs();
      return jobs.data;
    }

    if (openJobSelectionModal) {
      // Call the async function and await its result
      document.body.style.overflow = "hidden";
      setLoadingModal(true)
      getAlljobs().then((assigned) => {
        setLoadingModal(false)
        setAssignedJobs(assigned.jobs)
      }).catch((err) => {
        setLoadingModal(false)
        console.error(err)
      });
    } else {
      setLoadingModal(false)
      document.body.style.overflow = "auto";
    }
  }, [openJobSelectionModal]);


  const handleCandidateNameClick = async (candidate: any) => {
    setIsLoadingDetails(true);
    // setDetailsError(null);
    setShowCandidateDetailsModal(true);
    // Show row data immediately so optional fields like knownTools are not lost
    setSelectedCandidateForDetails(candidate as Candidate);
    try {
      const candidateId = candidate?.candidateId || candidate?.id;
      if (!candidateId) throw new Error("Candidate ID not found");

      const response = await getTalentPoolCandidateById(candidateId);
      if (!response?.data?.candidate) throw new Error("No candidate data returned from API");
      setSelectedCandidateForDetails((prev) => ({
        ...(prev || {}),
        ...response.data.candidate,
        knownTools: response.data.candidate?.knownTools ?? prev?.knownTools ?? [],
      }));
    } catch (err: any) {
      // setDetailsError(err.message || "Failed to fetch candidate details");
      toast.error(err.message || "Failed to fetch candidate details", { duration: 4000 });
    } finally {
      setIsLoadingDetails(false);
    }
  };



  const confirmStatusChange = async () => {
    if (!selectedCandidateId || !newStatus || !actionCandidate) return;
    try {
      await onStatusChange(actionCandidate, newStatus, comment || 'Status updated from Candidates Table');
      toast.success(`Candidate status updated to ${newStatus}`);
      setIsCommentDialogOpen(false);
      setIsConfirmDialogOpen(false);
      setComment('');
      setSelectedCandidateId(null);
      setNewStatus(null);
      setActionCandidate(null);
    } catch (err: any) {
      toast.error(err.message || 'Failed to update candidate status');
    }
  };

  const handleEditCandidate = (candidate: Candidate) => {
    navigate(`/edit-candidate/${candidate.id}`);
  };

  const handleDeleteCandidate = (candidate: Candidate) => {
    console.log(`Delete candidate with ID: ${candidate.id}`);
    toast.success('Candidate deleted successfully');
    setCandidates(candidates.filter(c => c.id !== candidate.id));
  };

  const handleCopyPublicLink = () => {
    if (!user?.id) {
      toast.error("User ID not available");
      return;
    }
    const publicLink = `${process.env.REACT_APP_NEXT_FRONT_END_URL}/jointalentpool/public/${user.id}`;
    navigator.clipboard
      .writeText(publicLink)
      .then(() => toast.success("Public link copied to clipboard!"))
      .catch(() => toast.error("Failed to copy link"));
  };

  const handleShareQR = async () => {
    if (!user?.id) {
      toast.error("User ID not available");
      return;
    }
    try {
      const publicLink = `${process.env.REACT_APP_NEXT_FRONT_END_URL}/jointalentpool/public/${user.id}`;
      const qrDataURL = await QRCode.toDataURL(publicLink, {
        width: 300,
        margin: 2,
        color: { dark: "#000000", light: "#FFFFFF" },
      });
      setQrCodeDataURL(qrDataURL);
      setShowQRModal(true);
    } catch (error) {
      toast.error("Failed to generate QR code");
    }
  };

  const handleDownloadQR = () => {
    const link = document.createElement("a");
    link.download = "talent-pool-qr-code.png";
    link.href = qrCodeDataURL;
    link.click();
    toast.success("QR code downloaded!");
  };


  const handleDownloadSampleCSV = () => {
    const sampleData = [
      // Header row
      ['name', 'email', 'phone', 'fatherName', 'dateOfBirth', 'gender', 'city', 'highestQualification', 'totalExperienceYears', 'totalExperienceMonths', 'skills', 'spokenLanguages', 'preferredJobCategories', 'preferredEmploymentTypes', 'preferredWorkTypes', 'street', 'area', 'pincode', 'fullAddress', 'aadharNumber'],
    
      // Data rows
      ['rajubai', 'rajubai.singh@email.com', '9812345600', 'Ramesh Singh', '2000-08-19', 'Male', 'Delhi', 'Bachelor of Science', '3', '5', 'Python, SQL, Tableau', 'English, Hindi', 'Data Analysis', 'Full-time', 'Hybrid', '12 MG Road', 'Connaught Place', '110001', '12 MG Road, Connaught Place, Delhi, India', '998877665544'],
      ['Anitabai', 'anitabai.kumar@email.com', '9823456700', 'Vikram Kumar', '1998-02-12', 'Female', 'Mumbai', 'Bachelor of Commerce', '2', '6', 'MS Excel, Tally', 'English, Marathi', 'Accounting', 'Full-time', 'On-site', '45 Marine Street', 'Bandra', '400050', '45 Marine Street, Bandra, Mumbai, Maharashtra, India', '887766554433'],
      ['Rohitbai', 'rohitbai.verma@email.com', '9834567800', 'Suresh Verma', '1995-10-25', 'Male', 'Pune', 'Diploma in Electrical Engineering', '4', '2', 'Electrical Maintenance, PLC', 'English, Marathi', 'Electrical Maintenance', 'Contract', 'On-site', '78 Tech Park', 'Hinjewadi', '411057', '78 Tech Park, Hinjewadi, Pune, Maharashtra, India', '776655443322'],
      ['Divyabai', 'divyabai.nair@email.com', '9845678900', 'Rajeev Nair', '1993-06-14', 'Female', 'Kochi', 'Master of Business Administration', '6', '4', 'Marketing, Communication', 'English, Malayalam', 'Sales, Marketing', 'Full-time', 'Hybrid', '101 Panampilly Drive', 'Panampilly Nagar', '682036', '101 Panampilly Drive, Panampilly Nagar, Kochi, Kerala, India', '665544332211'],
      ['Arjunbai', 'arjunbai.patel@email.com', '9856789110', 'Mahesh Patel', '2000-11-30', 'Male', 'Surat', 'Bachelor of Computer Applications', '1', '10', 'React, Node.js', 'English, Gujarati', 'Software Development', 'Internship', 'Remote', '34 Ring Road', 'Adajan', '395009', '34 Ring Road, Adajan, Surat, Gujarat, India', '554433221100']
    ];
    
    
    

    const csvContent = sampleData.map(row => 
      row.map(field => `"${field}"`).join(',')
    ).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'sample_candidates.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    toast.success('Sample CSV file downloaded!');
  };

  const getStatusBadgeColor = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'applied':
        return 'bg-white text-orange-600 border-orange-400 hover:border-orange-700 hover:bg-white hover:text-orange-700';
      case 'offered':
        return 'bg-gray-100 text-gray-700 border-gray-700 hover:border-gray-500 hover:bg-white hover:text-gray-700';
      case 'interview completed':
        return 'bg-green-100 text-green-600 border-green-600 hover:border-green-800 hover:bg-white hover:text-green-800';
      case 'selected':
        return 'bg-emerald-100 text-emerald-800 border-emerald-300';
      case 'shortlisted':
        return 'bg-emerald-100 text-emerald-800 border-emerald-300';  
      case 'rejected':
        return 'bg-rose-100 text-rose-800 border-rose-300';
      case 'placed':
        return 'bg-blue-100 text-blue-800 border-blue-300';
      case 'available':
        return 'bg-yellow-100 text-yellow-800 border-yellow-300';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300';
    }
  };

   // Toggle logic for Accept/Reject
  const handleAccept = async () => {
    try { 
      if(!selectedCandidateForShortList) return;
      const candidate:any = selectedCandidateForShortList;

      await updateTalentPoolApplications(candidate.candidateId, "shortlisted", selectedJobId);
      

      toast.success(`Application ${candidate.candidateId} accepted!`)

      setOpenJobSelectionModal(false)
      setTimeout(()=>{
        window.location.reload()
      },1000)
      
    } catch (error: any) {
     
      if (error.response?.status === 409) {
        toast.error("This application already exists or is duplicated.");
      } else {
        console.log(error)
        toast.error(error.response?.data?.message || "Something went wrong");
      }
    }
  };
  
  
  const handleReject = async(candidate: any) => {
     
      await updateTalentPoolApplications(candidate.candidateId,'rejected')
      toast.error(
        `Application ${candidate.candidateId} rejected!`
        );
        
        setTimeout(()=>{
        window.location.reload()
      },1000)
  };


  const SortableHeader: React.FC<{ column: string; children: React.ReactNode; className?: string }> = ({
    column,
    children,
    className,
  }) => (
    <th
      className={cn(
        'px-4 py-4 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:bg-muted/50 transition-colors sticky top-0 bg-[#FFF5F2] z-10',
        className,
      )}
      onClick={() => onSort(column)}
    >
      <div className="flex items-center gap-1">
        {children}
        {sortBy === column && (
          sortOrder === 'asc' ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />
        )}
      </div>
    </th>
  );



  const renderPagination = () => {
    const pageNumbers = [];
    const maxPagesToShow = 6;

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1 || candidatesLoading}
        >
          <ChevronLeft className="w-4 h-4" />
        </Button>

        {pageNumbers.map(page => (
          <Button
            key={page}
            variant={currentPage === page ? 'default' : 'outline'}
            size="sm"
            onClick={() => onPageChange(page)}
            disabled={candidatesLoading}
            className={currentPage === page ? 'bg-[#EC6E51] text-primary-foreground' : ''}
          >
            {page}
          </Button>
        ))}

        {endPage < totalPages && (
          <>
            <span className="text-sm text-muted-foreground">...</span>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onPageChange(totalPages)}
              disabled={candidatesLoading}
            >
              {totalPages}
            </Button>
          </>
        )}

        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages || candidatesLoading}
        >
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    );
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value;
  setSelectedJobId("")
  setJobSearchValue(value);

  // Clear previous timeout
  if (searchTimeout) clearTimeout(searchTimeout);

  // Set new timeout
  const timeout = setTimeout(async () => {
    setLoadingModal(true)
    await getJobs({ page: 1, limit: 100, search: value }).then(jobs=>{
      setLoadingModal(false)
      setAssignedJobs(jobs.data.jobs)
    });
  }, 1500);

  setSearchTimeout(timeout);
};


  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 p-0">
      {openJobSelectionModal && <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50" onClick={() => { setOpenJobSelectionModal(false) }} >
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 relative" onClick={(e) => e.stopPropagation()} >
          {/* Close Button */}
          <button
            onClick={() => { setOpenJobSelectionModal(false) }}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          >
            <X className="w-5 h-5" />
          </button>

          {/* Modal Content */}
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Select job to assign</h2>

          <div className="relative mb-4">
            <input
              type="text"
              placeholder="Search jobs..."
              className="w-full pl-4 pr-4 py-2 border border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200"
              value={jobSearchValue}
              onChange={handleSearchChange}
            />
          </div>

          <div className="max-h-64 overflow-y-auto border rounded-lg">
  {loadingModal ? (
    <div className="px-4 py-6 text-center text-gray-500">
      <p className="font-medium">Loading...</p>
    </div>
  ) : assignedJobs.length > 0 ? (
    assignedJobs.map(job => (
      <div
        key={job.id}
        className={cn(
          "px-4 py-3 cursor-pointer transition-all duration-150 text-gray-900",
          selectedJobId === job.id
            ? "bg-blue-50 border-r-4 border-blue-500" // selected background
            : "hover:bg-gray-50" // default hover background
        )}
        onClick={() => setSelectedJobId(job.id)}
      >
        <div className="flex items-center space-x-3">
          <div className="w-2 h-2 rounded-full bg-gray-300" />
          <div className="flex flex-col">
            <span className="font-semibold text-gray-900">{job.title}</span>
            <span className="text-gray-600 text-sm">{job.companyName}</span>
            <span className="text-gray-500 text-sm">{job.location}</span>
          </div>
        </div>
      </div>
    ))
  ) : (
    <div className="px-4 py-6 text-center text-gray-500">
      <p className="font-medium">No jobs found</p>
      <p className="text-sm">Try adjusting your search terms</p>
    </div>
  )}
</div>


          <div className="flex w-full gap-3 mt-4">
            {/* Cancel Button */}
            <Button
              variant="outline"
              size="sm"
              className={cn(
                "flex-1 rounded-md border border-gray-300 px-3 py-1 text-sm font-medium text-gray-500 bg-white hover:bg-gray-50 justify-center"
              )}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedJobId("")
                setOpenJobSelectionModal(false)
              }}
            >
              Cancel
            </Button>

            {/* Select Button */}
            <Button
              variant="outline"
              size="sm"
              className={cn(
                "flex-1 rounded-md border border-orange-300 px-3 py-1 text-sm font-medium text-orange-500 bg-white hover:bg-orange-50 justify-center"
              )}
              onClick={(e) => {
                e.stopPropagation();
                handleAccept()
              }}
              disabled={!selectedJobId}
            >
              Submit
            </Button>
          </div>

        </div>

      </div>}
  
    <Card className="mb-6 sm:mb-8 shadow-xl border-0 bg-white/80 backdrop-blur-sm" style={{
    margin: "0px",
    padding: "20px 10px",
    borderRadius: "0px",
    }}>

      <div className="flex items-center gap-4">
        
        <Button
          variant="ghost"
          size="lg"
          className="p-2 rounded-full hover:bg-gray-100 transition-colors"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-9 w-9 text-gray-600" style={{ width: "30px", height: "30px" }} />
        </Button>
        <div className="flex flex-col gap-4 w-full">
        <div className="flex-grow flex justify-between items-center">
          <div>
            <h1 className="text-xl lg:text-2xl font-bold text-gray-900">Candidates</h1>
            <p className="text-sm text-gray-600 font-medium">Manage and track candidate profiles seamlessly</p>
          </div>
          <div className="flex gap-3">
            {user && (
              <TooltipProvider>
                <>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        onClick={handleCopyPublicLink}
                        className="bg-white border border-orange-500 text-orange-600 hover:bg-orange-50 px-4 py-2 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2"
                      >
                        <Link className="h-4 w-4" />
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Copy Public Link</p>
                    </TooltipContent>
                  </Tooltip>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        onClick={handleShareQR}
                        className="bg-white border border-orange-500 text-orange-600 hover:bg-orange-50 px-4 py-2 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2"
                      >
                        <QrCode className="h-4 w-4" />
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Share QR Code</p>
                    </TooltipContent>
                  </Tooltip>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        onClick={handleBulkUpload}
                        className="bg-white border border-orange-500 text-orange-600 hover:bg-orange-50 px-4 py-2 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2"
                      >
                        <Upload className="h-4 w-4" />
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Bulk Upload Candidates</p>
                    </TooltipContent>
                  </Tooltip>
                  <Button
                    onClick={() => navigate("/talentpoolform")}
                    className="bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white px-4 py-2 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2"
                  >
                    <Plus className="h-4 w-4" />
                    Add Candidate
                  </Button>
                </>
              </TooltipProvider>
            )}
            {onAddCandidate && (
              <Button
                onClick={onAddCandidate}
                className="bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white px-4 py-2 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2"
              >
                <Plus className="h-4 w-4" />
                Add Candidate
              </Button>
            )}
          </div>
        </div>
          <div className="flex items-center gap-2 flex-1">
            <div className="relative flex-1 sm:max-w-[100%] md:max-w-[90%] lg:max-w-[50%]">
              <Search className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
              <Input
                placeholder="Search by name, email, phone..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-12 h-12 rounded-xl border-gray-200 focus:ring-2 focus:ring-orange-500 transition-all duration-200 bg-white/50"
              />
            </div>
            
            {/* Date Range Filter */}
            <div className="flex items-center gap-2">
              <Input
                type="date"
                value={selectedDateFrom}
                onChange={(e) => setSelectedDateFrom(e.target.value)}
                max={selectedDateTo || undefined}
                className="w-full sm:w-40 h-12 rounded-xl border-gray-200 focus:ring-2 focus:ring-orange-500 bg-white/50"
                title="From Date"
              />
              <Input
                type="date"
                value={selectedDateTo}
                onChange={(e) => setSelectedDateTo(e.target.value)}
                min={selectedDateFrom || undefined}
                className="w-full sm:w-40 h-12 rounded-xl border-gray-200 focus:ring-2 focus:ring-orange-500 bg-white/50"
                title="To Date"
              />
                              <div className="w-full sm:w-[180px]">
                                <Select
                                  value={category}
                                  onValueChange={(v) => {
                                    setCategory(v)
                                    onPageChange(1)
                                  }}
                                >
                                  <SelectTrigger className="w-full h-10 rounded-lg border-gray-200 focus:ring-2 focus:ring-orange-500">
                                    <div className="flex flex-wrap sm:flex-nowrap items-center gap-2 w-full sm:w-auto">
                                      <SelectValue placeholder="All Categories" />
                                    </div>
                                  </SelectTrigger>
                                  <SelectContent>
                                    <SelectItem value="all">All Categories</SelectItem>
                                    {categoryOptions.map(category => (
                                      <SelectItem key={category.value} value={category.value}>
                                        {category.label}
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                                </div>

                              <div className="w-full sm:w-[220px]">
                                <Popover open={openSourcedByDropdown} onOpenChange={setOpenSourcedByDropdown}>
                                  <PopoverTrigger asChild>
                                    <Button
                                      variant="outline"
                                      role="combobox"
                                      aria-expanded={openSourcedByDropdown}
                                      className="w-full h-10 justify-between rounded-lg border-gray-200 focus:ring-2 focus:ring-orange-500 bg-white/50 font-medium"
                                    >
                                      <span className="text-gray-600 truncate">
                                        {sourcedBy === "all"
                                          ? "All Sourcers"
                                          : (sourcedByOptions.find((u) => u.id === sourcedBy)?.name || "Select sourcer")}
                                      </span>
                                      <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                                    </Button>
                                  </PopoverTrigger>
                                  <PopoverContent className="w-[320px] p-0" align="start">
                                    <Command>
                                      <CommandInput placeholder="Search sourcer..." className="h-9" />
                                      <CommandEmpty>No users found.</CommandEmpty>
                                      <CommandGroup>
                                        <CommandList className="max-h-60">
                                          <CommandItem
                                            value="All Sourcers"
                                            onSelect={() => {
                                              setSourcedBy("all")
                                              onPageChange(1)
                                              setOpenSourcedByDropdown(false)
                                            }}
                                            className="cursor-pointer"
                                          >
                                            <div className="flex items-center justify-between w-full">
                                              <span>All Sourcers</span>
                                              {sourcedBy === "all" && <Check className="h-4 w-4 text-orange-600" />}
                                            </div>
                                          </CommandItem>

                                          {sourcedByOptions.map((u) => {
                                            const label = `${u.name}${u.email ? ` (${u.email})` : ""}`
                                            return (
                                              <CommandItem
                                                key={u.id}
                                                value={label}
                                                onSelect={() => {
                                                  setSourcedBy(u.id)
                                                  onPageChange(1)
                                                  setOpenSourcedByDropdown(false)
                                                }}
                                                className="cursor-pointer"
                                              >
                                                <div className="flex items-center justify-between w-full">
                                                  <span className="truncate">{label}</span>
                                                  {sourcedBy === u.id && <Check className="h-4 w-4 text-orange-600" />}
                                                </div>
                                              </CommandItem>
                                            )
                                          })}
                                        </CommandList>
                                      </CommandGroup>
                                    </Command>
                                  </PopoverContent>
                                </Popover>
                              </div>

                              <div className="w-full sm:w-[200px]">
                                <Select
                                  value={applicationsStatus}
                                  onValueChange={(v) => {
                                    setApplicationsStatus(v)
                                    onPageChange(1)
                                  }}
                                >
                                  <SelectTrigger className="w-full h-10 rounded-lg border-gray-200 focus:ring-2 focus:ring-orange-500">
                                    <div className="flex flex-wrap sm:flex-nowrap items-center gap-2 w-full sm:w-auto">
                                      <SelectValue placeholder="Application Status" />
                                    </div>
                                  </SelectTrigger>
                                  <SelectContent>
                                    <SelectItem value="all">All</SelectItem>
                                    <SelectItem value="shortlisted">Shortlisted</SelectItem>
                                    <SelectItem value="rejected">Rejected</SelectItem>
                                    <SelectItem value="no_action">No action</SelectItem>
                                  </SelectContent>
                                </Select>
                              </div>

            </div>
          </div>
        
        </div>
      </div>

      {/* QR Code Modal */}
      <Dialog open={showQRModal} onOpenChange={setShowQRModal}>
        <DialogContent className="max-w-md w-full p-6 sm:p-8 rounded-2xl">
          <DialogHeader className="mb-6">
            <DialogTitle className="text-xl font-bold text-gray-900">Share QR Code</DialogTitle>
          </DialogHeader>
          <div className="text-center">
            <div className="mb-4 flex justify-center">
              <div className="bg-white p-4 rounded-xl shadow-lg">
                <img src={qrCodeDataURL} alt="QR Code" className="w-64 h-64 mx-auto" />
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-6">Scan this QR code to access the talent pool form</p>
            <div className="flex gap-3 justify-center">
              <Button
                onClick={handleDownloadQR}
                className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-4 py-2 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2"
              >
                <Plus className="h-4 w-4" />
                Download QR
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Bulk Upload Modal */}
      <Dialog open={showBulkUploadModal} onOpenChange={(open) => {
        setShowBulkUploadModal(open);
        if (!open) {
          setIsDragOver(false);
        }
      }}>
        <DialogContent className="max-w-md w-full p-6 sm:p-8 rounded-2xl">
          <DialogHeader className="mb-6">
            <DialogTitle className="text-xl font-bold text-gray-900">Bulk Upload Candidates</DialogTitle>
            <DialogDescription className="text-sm text-gray-600 mt-2">
              Upload a CSV or XLSX file with candidate details to add multiple candidates at once. Download the sample file to see the required format.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div 
              className={`border-2 border-dashed rounded-lg p-6 text-center transition-all duration-200 ${
                isDragOver 
                  ? 'border-orange-500 bg-orange-50' 
                  : 'border-gray-300 hover:border-orange-400'
              }`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <Upload className={`h-12 w-12 mx-auto mb-4 transition-colors ${
                isDragOver ? 'text-orange-500' : 'text-gray-400'
              }`} />
              <p className={`text-sm mb-2 transition-colors ${
                isDragOver ? 'text-orange-600' : 'text-gray-600'
              }`}>
                {isDragOver ? 'Drop file here' : 'Click to upload or drag and drop'}
              </p>
              <p className="text-xs text-gray-500">CSV and XLSX files only (max 10MB)</p>
              <input
                type="file"
                accept=".csv,.xlsx"
                className="hidden"
                id="bulk-upload-input"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    handleFileUpload(file);
                  }
                }}
              />
              <Button
                onClick={() => document.getElementById('bulk-upload-input')?.click()}
                className="mt-4 bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white px-4 py-2 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200"
              >
                Choose File
              </Button>
            </div>
            <div className="text-center">
              <p className="text-sm text-gray-600 mb-3">
                Need help with the format?{' '}
                <button
                  onClick={handleDownloadSampleCSV}
                  className="text-orange-600 hover:text-orange-700 underline font-medium transition-colors duration-200"
                >
                  Download Sample CSV
                </button>
              </p>
              <p className="text-xs text-gray-500">Maximum 100 candidates per upload</p>
            </div>
          </div>
          <DialogFooter className="mt-6">
            <Button
              variant="outline"
              onClick={() => setShowBulkUploadModal(false)}
              className="px-4 py-2 rounded-xl"
            >
              Cancel
            </Button>
            <Button
              className="bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white px-4 py-2 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200"
              onClick={() => {
                if (uploadedFile) {
                  handleFileUpload(uploadedFile);
                } else {
                  toast.error("Please select a file first");
                }
              }}
            >
              Upload Candidates
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>


      {/* Search Card */}
        <CardContent className="py-0 px-8">
          
        </CardContent>
      </Card>

      {/* Candidates Table - Desktop */}
      <Card className="hidden lg:block shadow-xl border-0 bg-white/80 backdrop-blur-sm">
       <div className="max-h-[calc(100vh-200px)] overflow-y-auto" style={{ maxWidth: '100vw' }}>
        <table className="min-w-full divide-y divide-border">
            <thead style={{ backgroundColor: '#FFF5F2' }}>
              <tr>
                <th className="px-4 py-3 w-12 sticky top-0 bg-[#FFF5F2] z-10"></th>
                <SortableHeader column="name" className="min-w-48 sticky left-0 bg-[#FFF5F2] z-20 border-r border-border">
                  Name
                </SortableHeader>
                <SortableHeader column="email" className="bg-[#FFF5F2] min-w-64">Email</SortableHeader>
                <SortableHeader column="phone" className="bg-[#FFF5F2] min-w-32">Phone</SortableHeader>
                <SortableHeader column="availabilityStatus" className="bg-[#FFF5F2] min-w-32">Status</SortableHeader>
                <SortableHeader column="sourcedBy.username" className="bg-[#FFF5F2] min-w-48">Sourced By</SortableHeader>

                <SortableHeader column="createdAt" className="bg-[#FFF5F2] min-w-40">Applied On</SortableHeader>
                <SortableHeader column="sourcedBy.username" className="bg-[#FFF5F2] min-w-48">Actions</SortableHeader>
                
              </tr>
            </thead>
            <tbody className="bg-background divide-y divide-border">
              {candidatesLoading ? (
                <>
                  {[...Array(10)].map((_, index) => (
                    <tr key={`shimmer-${index}`} className="animate-pulse">
                      <td className="px-4 py-4">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
                          <div className="w-32 h-4 bg-gray-200 rounded"></div>
                        </div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="w-40 h-4 bg-gray-200 rounded"></div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="w-48 h-4 bg-gray-200 rounded"></div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="w-24 h-4 bg-gray-200 rounded"></div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="w-20 h-6 bg-gray-200 rounded-full"></div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="w-28 h-4 bg-gray-200 rounded"></div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="w-24 h-4 bg-gray-200 rounded"></div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="w-20 h-8 bg-gray-200 rounded"></div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="w-16 h-8 bg-gray-200 rounded"></div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex gap-2">
                          <div className="w-12 h-8 bg-gray-200 rounded"></div>
                          <div className="w-12 h-8 bg-gray-200 rounded"></div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </>
              ) : candidates.length === 0 ? (
                <tr>
                  <td colSpan={10} className="px-4 py-12 text-center">
                    <p className="text-muted-foreground">No candidates found matching your criteria.</p>
                  </td>
                </tr>
              ) : (
                candidates.map((candidate) => (
                  <tr
                    key={candidate.id}
                    className={cn('hover:bg-muted/30 transition-colors cursor-pointer')}
                    onClick={() => handleCandidateNameClick(candidate)}
                  >
                    <td className="px-4 py-4"></td>
                    <td className="px-4 py-4 sticky left-0 bg-white z-10 border-r border-border relative group">
                      <div className="flex items-center gap-3">
                        <span className="font-medium transition-colors cursor-pointer text-foreground hover:text-primary">
                          {candidate.name}
                        </span>
                      </div>
                      <div className="absolute top-0 left-[calc(100%+0.5rem)] mt-1 w-80 p-4 bg-white shadow-lg rounded border border-border opacity-0 pointer-events-none transition-opacity group-hover:opacity-100 group-hover:pointer-events-auto z-30">
                        <div className="flex items-center justify-between">
                          <h4 className="font-semibold text-lg">{candidate.name}</h4>
                          <Badge variant="secondary" className="text-xs">
                            {candidate.availabilityStatus || 'N/A'}
                          </Badge>
                        </div>
                        <div className="space-y-2 text-sm">
                          <div className="flex justify-between">
                            <span className="text-muted-foreground">Qualification:</span>
                            <span className="font-medium">{candidate.highestQualification}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-muted-foreground">Location:</span>
                            <div className="max-w-48 truncate" title={candidate.currentLocationDetails?.fullAddress}>
                              {candidate.currentLocationDetails?.fullAddress}
                            </div>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-muted-foreground">Phone:</span>
                            <span className="font-medium">{candidate.phone}</span>
                          </div>
                          <div>
                            <span className="text-muted-foreground">Skills:</span>
                            <p className="font-medium mt-1 break-words">
                              {candidate.skills?.length ? candidate.skills.slice(0, 3).join(", ") : "N/A"}
                            </p>
                          </div>
                          <div>
                            <span className="text-muted-foreground">Known Tools:</span>
                            <p className="font-medium mt-1 break-words">
                              {getCandidateTools(candidate).length ? getCandidateTools(candidate).slice(0, 3).join(", ") : "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="pt-2 border-t border-border">
                          <div className="text-xs text-muted-foreground">
                            Joined {new Date(candidate.profileCreatedAt).toLocaleDateString()}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-4 text-sm text-foreground">
                      <span
                        className="cursor-pointer hover:text-orange-600"
                        title="Copy email"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigator.clipboard.writeText(candidate.email);
                          toast.success('Email copied!');
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.textDecoration = 'underline';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.textDecoration = 'none';
                        }}
                      >
                        {candidate.email}
                      </span>
                    </td>
                    <td className="px-4 py-4 text-sm text-foreground">
                      <span
                        className="cursor-pointer hover:text-orange-600"
                        title="Copy phone number"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigator.clipboard.writeText(candidate.phone);
                          toast.success('Phone number copied!');
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.textDecoration = 'underline';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.textDecoration = 'none';
                        }}
                      >
                        {candidate.phone}
                      </span>
                    </td>
                    <td className="px-4 py-4">
                      <Badge className={getStatusBadgeColor(candidate.availabilityStatus)}>
                        {candidate.availabilityStatus || 'N/A'}
                      </Badge>
                    </td>
                    <td className="px-4 py-4 text-sm text-foreground">{candidate.sourcedBy?.name || 'N/A'}</td>

                    <td className="px-4 py-4 text-sm text-muted-foreground">
                      {new Date(candidate.createdAt).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </td>
                    <td className="px-4 py-4 text-sm text-muted-foreground">
                      { candidate.status === "applied" && !['FREELANCE_COUNSELLOR'].includes(user?.role || '' ) ? <div className="flex gap-2">
                        <Button
                        variant="outline"
                        size="sm"
                        className={cn(
                          "rounded-md border border-orange-300 px-3 py-1 text-sm font-medium text-orange-500 bg-white hover:bg-orange-50"
                        )}
                        // disabled={loadingId == app._id}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedCandidateForShortList(candidate)
                          setOpenJobSelectionModal(true)
                        }}
                      >
                         Shortlist
                      </Button>

                      <Button
                        variant="outline"
                        size="sm"
                        className={cn(
                          "rounded-md border border-orange-300 px-3 py-1 text-sm font-medium text-orange-500 bg-white hover:bg-orange-50"
                        )}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleReject(candidate);
                        }}
                      >
                        Reject
                      </Button>
                      </div> :  <Badge className={getStatusBadgeColor(candidate.status || "N/A")}>
                        {candidate.status}
                      </Badge>}
                       
                    </td>
                   
                   
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Candidates Cards - Mobile & Tablet */}
      <div className="lg:hidden space-y-4 sm:space-y-6">
        {candidates.map((candidate) => (
          <Card
            key={candidate.id}
            className="shadow-xl rounded-2xl border-0 bg-white/80 backdrop-blur-sm overflow-hidden"
          >
            <CardContent className="p-4 sm:p-6">
              <div className="space-y-4" onClick={() => handleCandidateNameClick(candidate)}>
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-3">
                    <div className="h-10 w-10 sm:h-12 sm:w-12 bg-gradient-to-br from-orange-500 to-amber-600 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-lg">
                      {candidate.name.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <span className="font-bold text-gray-900 text-base sm:text-lg">{candidate.name}</span>
                      <p className="text-xs sm:text-sm text-gray-500 flex items-center gap-1">
                        ID: {candidate.id?.slice(-8)}
                      </p>
                    </div>
                  </div>
                
                </div>
                <div className="grid grid-cols-1 gap-3">
                  <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
                    <span className="text-sm text-gray-900 truncate">{candidate.email}</span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
                    <span className="text-sm text-gray-900">{candidate.phone}</span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
                    <span className="text-sm text-gray-900">
                      {new Date(candidate.profileCreatedAt).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </span>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
        {candidatesLoading && (
          <div className="text-center py-12">
            <div className="flex justify-center items-center flex-col gap-4">
              <div className="animate-spin inline-block h-10 w-10 border-4 border-orange-600 border-t-transparent rounded-full"></div>
              <p className="text-lg text-gray-600">Loading candidates...</p>
            </div>
          </div>
        )}
        {!candidatesLoading && candidates.length === 0 && (
          <div className="text-center py-12">
            <p className="text-lg text-gray-600">No candidates found.</p>
          </div>
        )}
      </div>

      {/* Candidate Details Modal */}
      <Dialog open={showCandidateDetailsModal} onOpenChange={setShowCandidateDetailsModal}>
        <DialogContent className="max-w-xs sm:max-w-md md:max-w-2xl lg:max-w-4xl xl:max-w-5xl max-h-[90vh] overflow-y-auto rounded-2xl sm:rounded-3xl">
          <DialogHeader className="pb-4">
            <DialogTitle className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 flex flex-col sm:flex-row items-start sm:items-center gap-3">
              {selectedCandidateForDetails && (
                <>
                  <div className="h-10 w-10 sm:h-12 sm:w-12 bg-orange-600 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-lg">
                    {selectedCandidateForDetails.name.charAt(0).toUpperCase()}
                  </div>
                  <span className="break-words">{selectedCandidateForDetails.name}</span>
                </>
              )}
            </DialogTitle>
          </DialogHeader>
          {isLoadingDetails ? (
            <div className="text-center py-8 sm:py-12">
              <div className="animate-spin inline-block h-8 w-8 sm:h-10 sm:w-10 border-4 border-orange-600 border-t-transparent rounded-full mb-4"></div>
              <p className="text-base sm:text-lg text-gray-600">Loading candidate details...</p>
            </div>
          ) : selectedCandidateForDetails ? (
            <div className="space-y-4 sm:space-y-6 p-0">
              {selectedCandidateForDetails.resumeUrl && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => window.open(selectedCandidateForDetails.resumeUrl, '_blank')}
                  className="p-2 rounded-full text-white bg-orange-600 hover:bg-gray-100"
                >
                  <Eye className="h-5 w-5" />
                  Preview Resume
                </Button>
              )}
              <div className="bg-gradient-to-r from-orange-50 to-indigo-50 rounded-xl p-4 sm:p-6">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                  <User className="h-4 w-4 sm:h-5 sm:w-5 text-orange-600" />
                  Basic Information
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <Mail className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Email</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base break-words">
                          {selectedCandidateForDetails.email}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <Phone className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Phone</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.phone}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <User className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Father's Name</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.fatherName || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <UserCheck className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Gender</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.gender || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <MapPin className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Location</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.currentLocationDetails?.city || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <Baby className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Date of Birth</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.dateOfBirth
                            ? new Date(selectedCandidateForDetails.dateOfBirth).toLocaleDateString("en-GB")
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <CreditCard className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Aadhar Number</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.aadharNumber || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <GraduationCap className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Highest Qualification</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.highestQualification || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <Languages className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Spoken Languages</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.spokenLanguages?.length
                            ? selectedCandidateForDetails.spokenLanguages.join(", ")
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <Briefcase className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Experience</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.totalExperienceYears !== undefined &&
                          selectedCandidateForDetails.totalExperienceMonths !== undefined
                            ? `${selectedCandidateForDetails.totalExperienceYears} years ${selectedCandidateForDetails.totalExperienceMonths} months`
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <Award className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Skills</p>
                        <div className="flex flex-wrap gap-1 mt-1">
                          {selectedCandidateForDetails.skills?.length ? (
                            selectedCandidateForDetails.skills?.slice(0, 3).map((skill, index) => (
                              <Badge key={index} variant="secondary" className="text-xs">
                                {skill}
                              </Badge>
                            ))
                          ) : (
                            <span className="font-medium text-gray-900 text-sm sm:text-base">N/A</span>
                          )}
                          {selectedCandidateForDetails.skills?.length > 3 && (
                            <Badge variant="secondary" className="text-xs">
                              +{selectedCandidateForDetails.skills.length - 3} more
                            </Badge>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <Briefcase className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Known Tools</p>
                        <div className="flex flex-wrap gap-1 mt-1">
                          {getCandidateTools(selectedCandidateForDetails).length ? (
                            getCandidateTools(selectedCandidateForDetails).slice(0, 3).map((tool, index) => (
                              <Badge key={index} variant="secondary" className="text-xs">
                                {tool}
                              </Badge>
                            ))
                          ) : (
                            <span className="font-medium text-gray-900 text-sm sm:text-base">N/A</span>
                          )}
                          {getCandidateTools(selectedCandidateForDetails).length > 3 && (
                            <Badge variant="secondary" className="text-xs">
                              +{getCandidateTools(selectedCandidateForDetails).length - 3} more
                            </Badge>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-r from-orange-50 to-indigo-50 rounded-xl p-4 sm:p-6">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                  <Briefcase className="h-4 w-4 sm:h-5 sm:w-5 text-orange-600" />
                  Professional Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex flex-col sm:flex-row sm:justify-between gap-3">
                    <div className="flex items-start gap-3">
                      <Building className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Job Category</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.preferredJobCategories?.length
                            ? selectedCandidateForDetails.preferredJobCategories.join(", ")
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <UserCheck className="h-4 w-4 text-gray-500 mt-1 flex-shrink-0" />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm text-gray-600">Employment Type</p>
                        <p className="font-medium text-gray-900 text-sm sm:text-base">
                          {selectedCandidateForDetails.preferredEmploymentTypes?.length
                            ? selectedCandidateForDetails.preferredEmploymentTypes.join(", ")
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white border border-gray-200 rounded-xl p-4 sm:p-6">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 text-orange-600" />
                  Application Status
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs sm:text-sm text-gray-600 mb-2">Current Status</p>
                    <Badge
                      className={`${getStatusBadgeColor(selectedCandidateForDetails.availabilityStatus || "")} border font-medium px-3 py-1 text-xs sm:text-sm`}
                    >
                      {selectedCandidateForDetails.availabilityStatus || "N/A"}
                    </Badge>
                  </div>
                  <div>
                    <p className="text-xs sm:text-sm text-gray-600 mb-2">Sourced By</p>
                    <div className="flex items-center gap-2">
                      <User className="h-4 w-4 text-gray-400" />
                      <span className="font-medium text-gray-900 text-sm sm:text-base">
                        {selectedCandidateForDetails.sourcedBy?.name ?? "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </DialogContent>
      </Dialog>

      {/* Application History Dialog */}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="bg-white shadow-lg rounded-lg border border-gray-200 max-w-md px-[16px] py-[25px] gap-2">
          <DialogHeader>
            <DialogTitle className="font-semibold text-lg mb-4 text-gray-800">
              Application History of <span className="font-bold text-[#EC6E51]">{selectedCandidateName}</span>
            </DialogTitle>
          </DialogHeader>
          <ScrollArea className="max-h-[400px]">
            {selectedCandidateApplications.length === 0 ? (
              <p className="text-sm text-gray-500">No applications found for {selectedCandidateName}.</p>
            ) : (
              selectedCandidateApplications
                .sort((a, b) => new Date(b.appliedOn).getTime() - new Date(a.appliedOn).getTime())
                .map((app, index) => (
                  <div
                    key={index}
                    className="relative flex items-start border-b border-gray-100 pb-4 last:border-b-0"
                  >
                    <div className="relative flex items-center justify-center w-6 h-6 mr-4">
                      <motion.div
                        className={`w-4 h-4 z-10 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors duration-300 ${
                          index < progress ? 'bg-[#ED795F] border-[#ED795F] text-white' : 'bg-white border-gray-300'
                        }`}
                        initial={{ scale: 1, opacity: 1 }}
                        animate={{
                          scale: index < progress ? [1, 1.2, 1] : 1,
                          opacity: index < progress ? [1, 0.8, 1] : 1,
                        }}
                        transition={{
                          duration: 0.8,
                          repeat: index < progress && app.currentStatus.status === 'Active' ? Infinity : 0,
                          ease: 'easeInOut',
                        }}
                      >
                        {index < progress && app.currentStatus.status !== 'Active' && (
                          <svg
                            className="w-3 h-3"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        )}
                      </motion.div>
                      {index < progress && app.currentStatus.status === 'Active' && (
                        <>
                          <motion.div
                            className="absolute left-0 rounded-full border-2 border-[#ED795F] bg-transparent z-0"
                            style={{
                              width: '75%',
                              height: '75%',
                              top: '13%',
                              left: '10.2%',
                              transform: 'translate(-50%, -50%)',
                            }}
                            animate={{
                              scale: [1, 1.8, 2.4],
                              opacity: [0.7, 0.4, 0],
                            }}
                            transition={{
                              duration: 1,
                              repeat: Infinity,
                              ease: 'easeOut',
                            }}
                          />
                          <motion.div
                            className="absolute rounded-full border-2 border-[#ED795F] bg-transparent z-0"
                            style={{
                              width: '75%',
                              height: '75%',
                              top: '13%',
                              left: '10.2%',
                              transform: 'translate(-50%, -50%)',
                            }}
                            animate={{
                              scale: [1, 1.8, 2.4],
                              opacity: [0.7, 0.4, 0],
                            }}
                            transition={{
                              duration: 1,
                              repeat: Infinity,
                              ease: 'easeOut',
                              delay: 0.3,
                            }}
                          />
                        </>
                      )}
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-1">
                        <span className={`font-semibold text-sm ${index < progress ? 'text-gray-800' : 'text-gray-400'}`}>
                          {app.job.title}
                        </span>
                      </div>
                      <div className="text-xs space-y-1">
                        <div className="flex justify-between">
                          <span className="text-gray-500">Company:</span>
                          <span className={`${index < progress ? 'text-gray-600' : 'text-gray-400'} font-medium`}>
                            {app.job.companyName}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-500">Applied On:</span>
                          <span className={`${index < progress ? 'text-gray-600' : 'text-gray-400'} font-medium`}>
                            {new Date(app.appliedOn).toLocaleDateString()}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-500">Status:</span>
                          <span className={`${index < progress ? 'text-gray-600' : 'text-gray-400'} font-medium`}>
                            {app.currentStatus.status || 'N/A'}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-500">Sourced By:</span>
                          <span className={`${index < progress ? 'text-gray-600' : 'text-gray-400'} font-medium`}>
                            {app.sourcedBy?.username || 'N/A'}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-500">Updated By:</span>
                          <span className={`${index < progress ? 'text-gray-600' : 'text-gray-400'} font-medium`}>
                            {app.currentStatus.updatedBy?.username || 'N/A'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
            )}
          </ScrollArea>
        </DialogContent>
      </Dialog>

      {/* Comment Dialog for Setting as Placed */}
      <Dialog open={isCommentDialogOpen} onOpenChange={setIsCommentDialogOpen}>
        <DialogContent className="sm:max-w-[500px] rounded-2xl bg-white/95 backdrop-blur-sm shadow-2xl">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-gray-900">Set Candidate as Placed</DialogTitle>
            <DialogDescription className="text-gray-600">
              Please provide a comment for setting the candidate status to Placed.
            </DialogDescription>
          </DialogHeader>
          <div className="py-4">
            <Textarea
              placeholder="Enter your comment here..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              className="w-full h-24 rounded-xl border-gray-200 focus:ring-2 focus:ring-orange-500"
            />
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => {
                setIsCommentDialogOpen(false);
                setComment('');
                setSelectedCandidateId(null);
                setNewStatus(null);
                setActionCandidate(null);
              }}
              className="rounded-xl border-gray-200"
            >
              Cancel
            </Button>
            <Button
              onClick={confirmStatusChange}
              disabled={!comment.trim()}
              className="rounded-xl bg-orange-600 text-white hover:bg-orange-700"
            >
              Confirm
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Confirmation Dialog for Setting as Available */}
      <AlertDialog open={isConfirmDialogOpen} onOpenChange={setIsConfirmDialogOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirm Status Change</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to set the candidate <strong>{actionCandidate?.name}</strong>'s status to Available?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => {
              setIsConfirmDialogOpen(false);
              setSelectedCandidateId(null);
              setNewStatus(null);
              setActionCandidate(null);
            }}>
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={confirmStatusChange}
              className="bg-orange-600 hover:bg-orange-700"
            >
              Confirm
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Pagination */}
      <div
        className="flex flex-col sm:flex-row items-center justify-between border-t bg-gradient-to-r from-gray-50 to-gray-100 px-3 sm:px-4 md:px-6 py-3 sm:py-4 md:py-5 gap-3 sm:gap-4 mt-4 sm:mt-6 rounded-xl"
        style={{
          position: "sticky",
          bottom: 0,
          left: 0,
          width: "100%",
          zIndex: 50,
          background: "linear-gradient(to right, #f9fafb, #f3f4f6)",
        }}
      >
        <div className="text-xs sm:text-sm text-gray-600 font-medium text-center sm:text-left">
          Showing {candidates.length} of {pagination.totalResults} candidates
        </div>
        {renderPagination()}
      </div>
    </div>
  );
};

export default function ViewCandidates({ onAddCandidate }: { onAddCandidate?: () => void }) {
  const { user } = useRbac() as { user: UserType | null };
  const [searchTerm, setSearchTerm] = useState("")
  const [isLoading, setIsLoading] = useState(true);
  const [selectedDateFrom, setSelectedDateFrom] = useState("")
  const [selectedDateTo, setSelectedDateTo] = useState("")
  const [category, setCategory] = useState("")
  const [sourcedBy, setSourcedBy] = useState<string>("all")
  const [applicationsStatus, setApplicationsStatus] = useState<string>("all")
  const [sourcedByUsers, setSourcedByUsers] = useState<Array<{ id: string; name: string; email?: string }>>([])

  const [candidates, setCandidates] = useState<Candidate[]>([]);
  const [sortBy, setSortBy] = useState('name');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [pagination,setPagination] = useState({})

  const [statusChangeLoading, setStatusChangeLoading] = useState<string | null>(null);
  const navigate=useNavigate();

  const sourcedByOptions = useMemo(() => {
    const base = (sourcedByUsers || []).slice();
    // ensure current user is also selectable
    if (user?.id) {
      const already = base.some((u) => u.id === user.id);
      if (!already) base.unshift({ id: user.id, name: user.username || 'You', email: user.email });
    }
    return base.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
  }, [sourcedByUsers, user?.id, user?.username, user?.email]);

  useEffect(() => {
    const fetchHierarchyUsers = async () => {
      try {
        const res = await getMySubordinates();
        const subs = (res as any)?.data?.subordinates || [];
        const formatted = subs.map((u: any) => ({
          id: u.id,
          name: u.username,
          email: u.email,
        }));
        setSourcedByUsers(formatted);
      } catch {
        // toast already handled in service
        setSourcedByUsers([]);
      }
    };
    fetchHierarchyUsers();
  }, []);

  // Bulk upload states
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [parsedData, setParsedData] = useState<any[]>([]);
  const [showPreviewPage, setShowPreviewPage] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const fetchCandidates = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await gettalentPoolCandidates({
        page: currentPage,
        limit: 10,
        search: searchTerm,
        dateFrom: selectedDateFrom || undefined,
        dateTo: selectedDateTo || undefined,
        category: category || undefined,
        recruiterId: sourcedBy && sourcedBy !== "all" ? sourcedBy : undefined,
        applicationStatus: applicationsStatus as any,
      });
     const apps = response.data.candidates as unknown as Candidate[];
      
      setCandidates(apps);
      setTotalPages(response.totalPages);
      setPagination({
        page:response?.page,
        limit:response?.limit,
        totalPages:response?.totalPages,
        totalResults:response?.totalResults
      })

    } catch (err: any) {
      toast.error(err.message || 'Failed to fetch candidates');
    }
    finally {
      setIsLoading(false);
    }
  }, [currentPage, sortBy, sortOrder, searchTerm, selectedDateFrom, selectedDateTo, category, sourcedBy, applicationsStatus]);

  useEffect(() => {
    fetchCandidates();
  }, [fetchCandidates]);



  const handleSort = (column: string) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(column);
      setSortOrder('asc');
    }
  };

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleStatusChange = async (candidate: Candidate, newStatus: string, comment?: string) => {
    setStatusChangeLoading(candidate.id);
    try {
      await MarkCandidateStatus(candidate.id, newStatus, comment || 'Status updated from Candidates Table');
      setCandidates(candidates.map(c =>
        c.id === candidate.id ? { ...c, availabilityStatus: newStatus } : c
      ));
    } catch (err: any) {
      toast.error(err.message || 'Failed to update candidate status');
    } finally {
      setStatusChangeLoading(null);
    }
  };

  // Bulk upload functions
  const handleBulkUpload = () => {
    setShowBulkUploadModal(true);
  };

  // Drag and drop handlers
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.type === 'text/csv' || file.name.endsWith('.csv') || 
          file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
          file.name.endsWith('.xlsx')) {
        handleFileUpload(file);
      } else {
        toast.error('Please upload only CSV or XLSX files');
      }
    }
  };

  // Standardized validation function for both CSV and XLSX
  const validateCandidateRow = (row: any): { isValid: boolean; missingFields: string[] } => {
    const requiredFields = [
      'name', 'email', 'phone', 'fatherName', 'dateOfBirth', 'gender', 'city', 
      'highestQualification', 'totalExperienceYears', 'totalExperienceMonths', 
      'skills', 'spokenLanguages', 'preferredJobCategories', 'preferredEmploymentTypes', 
      'preferredWorkTypes', 'street', 'area', 'pincode', 'fullAddress'
    ];
    
    const missingFields = requiredFields.filter(field => !row[field] || !String(row[field]).trim());
    
    return {
      isValid: missingFields.length === 0,
      missingFields
    };
  };

  const parseCSV = (csvText: string): any[] => {
    const lines = csvText.split('\n').filter(line => line.trim());
    if (lines.length < 2) {
      console.log('Not enough lines in CSV:', lines.length);
      return [];
    }

    console.log('CSV lines:', lines);

    // Parse header row - handle quoted fields properly
    const parseCSVLine = (line: string): string[] => {
      const result = [];
      let current = '';
      let inQuotes = false;
      
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        
        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          result.push(current.trim());
          current = '';
        } else {
          current += char;
        }
      }
      
      result.push(current.trim());
      return result;
    };

    const headers = parseCSVLine(lines[0]);
    console.log('Parsed headers:', headers);

    // Parse data rows
    const data = [];
    const skippedRows = [];
    for (let i = 1; i < lines.length; i++) {
      const values = parseCSVLine(lines[i]);
      console.log(`Row ${i} values:`, values);
      
      if (values.length === headers.length) {
        const row: any = {};
        headers.forEach((header, index) => {
          // Clean the header to remove "(Optional)" if present and normalize case
          const cleanHeader = header.replace(/\s*\(Optional\)\s*$/, '').trim();
          row[cleanHeader] = values[index];
        });
        data.push(row);
      } else {
        console.log(`Row ${i} has ${values.length} values but expected ${headers.length}`);
        skippedRows.push(i);
      }
    }

    // Log skipped rows for debugging
    if (skippedRows.length > 0) {
      console.warn(`Skipped ${skippedRows.length} rows due to column count mismatch:`, skippedRows);
    }

    console.log('Final parsed data:', data);
    return data;
  };

  const parseXLSX = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        try {
          const fileData = new Uint8Array(e.target?.result as ArrayBuffer);
          const workbook = XLSX.read(fileData, { type: 'array' });
          
          console.log('Workbook sheets:', workbook.SheetNames);
          
          // Get the first worksheet
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          
          // Try different parsing methods
          let jsonData: any[] = [];
          
          // Method 1: Try with header: 1 (array of arrays)
          try {
            jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            console.log('Method 1 (header: 1) - Raw XLSX data:', jsonData);
          } catch (error) {
            console.log('Method 1 failed:', error);
          }
          
          // Method 2: If method 1 fails or returns empty, try with header: 'A' (object format)
          if (!jsonData || jsonData.length === 0) {
            try {
              const objData = XLSX.utils.sheet_to_json(worksheet);
              console.log('Method 2 (object format) - Raw XLSX data:', objData);
              if (objData && objData.length > 0) {
                // Convert object format to array format
                const firstRow = objData[0] as Record<string, any>;
                const keys = Object.keys(firstRow);
                const typedObjData = objData as Record<string, any>[];
                const dataRows = typedObjData.map((row: Record<string, any>) => keys.map(key => row[key]));
                jsonData = [keys, ...dataRows];
                console.log('Converted to array format:', jsonData);
              }
            } catch (error) {
              console.log('Method 2 failed:', error);
            }
          }
          
          console.log('Final jsonData:', jsonData);
          console.log('Number of rows:', jsonData.length);
          
          if (!jsonData || jsonData.length < 2) {
            console.log('Not enough rows in XLSX:', jsonData.length);
            resolve([]);
            return;
          }
          
          // First row is headers
          const headers = jsonData[0] as string[];
          console.log('XLSX headers:', headers);
          
          // Clean headers - remove extra spaces and normalize (same as CSV processing)
          const cleanHeaders = headers.map(h => h ? String(h).trim() : '');
          console.log('Cleaned headers:', cleanHeaders);
          
          // Parse data rows
          const parsedData = [];
          const skippedRows = [];
          
          for (let i = 1; i < jsonData.length; i++) {
            const row = jsonData[i] as any[];
            console.log(`XLSX Row ${i} values:`, row);
            
            if (row && row.length > 0) {
              const rowData: any = {};
              let hasData = false;
              
              cleanHeaders.forEach((header, index) => {
                const value = row[index];
                const cleanValue = value ? String(value).trim() : '';
                rowData[header] = cleanValue;
                if (cleanValue) hasData = true;
              });
              
              console.log(`Row ${i} parsed data:`, rowData);
              
              // Use standardized validation
              const validation = validateCandidateRow(rowData);
              if (validation.isValid) {
                parsedData.push(rowData);
                console.log(`Row ${i} added to parsed data`);
              } else {
                console.log(`Row ${i} validation failed:`, validation.missingFields);
                skippedRows.push(i + 1);
              }
            } else {
              skippedRows.push(i + 1);
              console.log(`Row ${i} skipped - empty row`);
            }
          }
          
          if (skippedRows.length > 0) {
            console.log('Skipped rows:', skippedRows);
          }
          
          console.log('Final parsed XLSX data:', parsedData);
          console.log('Total parsed rows:', parsedData.length);
          
          resolve(parsedData);
        } catch (error) {
          console.error('Error parsing XLSX:', error);
          
          // Try alternative parsing method as fallback
          try {
            console.log('Trying alternative parsing method...');
            const fileData = new Uint8Array(e.target?.result as ArrayBuffer);
            const workbook = XLSX.read(fileData, { type: 'array', cellDates: true, cellNF: false, cellText: false });
            
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            
            // Try to get the range of the worksheet
            const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1:A1');
            console.log('Worksheet range:', range);
            
            // Convert to JSON with different options
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
              header: 1, 
              defval: '',
              blankrows: false 
            });
            
            console.log('Alternative parsing result:', jsonData);
            
            if (jsonData && jsonData.length > 1) {
              const headers = jsonData[0] as string[];
              // Clean headers consistently with main parsing method
              const cleanHeaders = headers.map(h => h ? String(h).trim() : '');
              const parsedData = [];
              
              for (let i = 1; i < jsonData.length; i++) {
                const row = jsonData[i] as any[];
                if (row && row.length > 0) {
                  const rowData: any = {};
                  cleanHeaders.forEach((header, index) => {
                    const value = row[index];
                    rowData[header] = value ? String(value).trim() : '';
                  });
                  
                  // Very lenient validation - just check if there's any data
                  const hasAnyData = Object.values(rowData).some(val => val && String(val).trim().length > 0);
                  if (hasAnyData) {
                    parsedData.push(rowData);
                  }
                }
              }
              
              console.log('Alternative parsing successful:', parsedData);
              resolve(parsedData);
              return;
            }
          } catch (fallbackError) {
            console.error('Fallback parsing also failed:', fallbackError);
          }
          
          reject(error);
        }
      };
      
      reader.onerror = () => {
        reject(new Error('Error reading XLSX file'));
      };
      
      reader.readAsArrayBuffer(file);
    });
  };

  const handleFileUpload = (file: File) => {
    if (!file) return;

    // Validate file type
    const validTypes = ['text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    if (!validTypes.includes(file.type) && !file.name.endsWith('.csv') && !file.name.endsWith('.xlsx')) {
      toast.error('Please upload a CSV or XLSX file');
      return;
    }

    // Validate file size (10MB)
    if (file.size > 10 * 1024 * 1024) {
      toast.error('File size must be less than 10MB');
      return;
    }

    setUploadedFile(file);

    // For CSV files, parse immediately
    if (file.name.endsWith('.csv')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const csvText = e.target?.result as string;
          console.log('Raw CSV text:', csvText);
          
          if (!csvText || csvText.trim().length === 0) {
            toast.error('File is empty');
            return;
          }

          const parsed = parseCSV(csvText);
          console.log('Parsed result:', parsed);
          console.log('Checking completeness for each row:');
          parsed.forEach((row, index) => {
            const validation = validateCandidateRow(row);
            console.log(`Row ${index + 1}:`, {
              ...row,
              isValid: validation.isValid,
              missingFields: validation.missingFields
            });
          });
          
          if (parsed.length === 0) {
            toast.error('No valid data found in the file. Please check the CSV format and ensure all rows have the correct number of columns.');
            return;
          }

          if (parsed.length > 100) {
            toast.error('Maximum 100 candidates allowed per upload');
            return;
          }

          // Check if we have the expected number of rows (header + data rows)
          const expectedRows = csvText.split('\n').filter(line => line.trim()).length - 1; // -1 for header
          if (parsed.length < expectedRows) {
            const skippedCount = expectedRows - parsed.length;
            toast(`⚠️ Parsed ${parsed.length} candidates successfully, but ${skippedCount} rows were skipped due to formatting issues. Please check the console for details.`, {
              icon: '⚠️',
              duration: 5000,
            });
          } else {
            toast.success(`Successfully parsed ${parsed.length} candidates`);
          }

          setParsedData(parsed);
          setShowBulkUploadModal(false);
          setShowPreviewPage(true);
        } catch (error) {
          console.error('Error parsing CSV:', error);
          toast.error('Error parsing CSV file. Please check the format.');
        }
      };
      reader.onerror = () => {
        toast.error('Error reading file');
      };
      reader.readAsText(file);
    } else if (file.name.endsWith('.xlsx') || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      // Handle XLSX files
      parseXLSX(file)
        .then((parsed) => {
          console.log('Parsed XLSX result:', parsed);
          console.log('Checking completeness for each row:');
          parsed.forEach((row, index) => {
            const validation = validateCandidateRow(row);
            console.log(`Row ${index + 1}:`, {
              isValid: validation.isValid,
              missingFields: validation.missingFields
            });
          });

          if (parsed.length === 0) {
            toast.error('No valid data found in the XLSX file. Please check the file format and ensure it has headers in the first row and data in subsequent rows.');
            return;
          }

          // Check for incomplete records using standardized validation
          const incompleteRecords = parsed.filter(row => !validateCandidateRow(row).isValid);

          if (incompleteRecords.length > 0) {
            toast.success(`Successfully parsed ${parsed.length} candidates`);
          } else {
            toast.success(`Successfully parsed ${parsed.length} candidates`);
          }

          setParsedData(parsed);
          setShowBulkUploadModal(false);
          setShowPreviewPage(true);
        })
        .catch((error) => {
          console.error('Error parsing XLSX:', error);
          toast.error('Error parsing XLSX file. Please check the format.');
        });
    } else {
      toast.error('Unsupported file format. Please use CSV or XLSX files.');
    }
  };

  const handleFinalSubmission = async () => {
    try {
        // Filter out incomplete records using standardized validation
        const completeRecords = parsedData.filter((row: any) => validateCandidateRow(row).isValid);

    

      // Show loading state
      toast.loading(`Uploading ${completeRecords.length} candidates...`);

      // Here you would call your API to upload the candidatesß
      // For now, we'll simulate the upload
      await bulkUploadTalentPoolCandidates(completeRecords);

      // Success
      toast.success(`Successfully uploaded ${completeRecords.length} candidates!`);
      
      // Reset states and close preview
      setShowPreviewPage(false);
      setParsedData([]);
      setUploadedFile(null);
      
      // Refresh the candidates list by reloading the page or calling the existing refresh function
      window.location.reload();

    } catch (error) {
      console.error('Upload error:', error);
      toast.error('Failed to upload candidates. Please try again.');
    }
  };

   const handleBackNavigation = () => {
    navigate(-1);
  };

  return (
    <>
      {/* Bulk Upload Preview Page */}
      {showPreviewPage ? (
        <div className="min-h-screen bg-gradient-to-br from-orange-50 p-0">
          <div className="p-6">
            {/* Header Section - Same as main table */}
            <div className="mb-6">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
                <div>
                  <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Review Uploaded Candidates</h1>
                  <p className="text-sm text-gray-600 font-medium">Please review the data below and confirm to proceed with bulk upload</p>
                </div>
                <div className="flex gap-3">
                  <Button
                    onClick={() => {
                      setShowPreviewPage(false);
                      setParsedData([]);
                      setUploadedFile(null);
                    }}
                    variant="outline"
                    className="px-4 py-2 rounded-xl"
                  >
                    <ArrowLeft className="h-4 w-4 mr-2" />
                    Back to Upload
                  </Button>
                  <Button
                    onClick={() => handleFinalSubmission()}
                    className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-2 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200"
                  >
                    <CheckCircle className="h-4 w-4 mr-2" />
                    Confirm & Submit ({parsedData.length} candidates)
                  </Button>
                </div>
              </div>
            </div>

            {/* Summary Stats */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <Card className="p-4">
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600">{parsedData.length}</div>
                  <div className="text-sm text-gray-600">Total Candidates</div>
                </div>
              </Card>
              <Card className="p-4">
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600">
                    {parsedData.filter((row: any) => row.name && row.email && row.phone && row.fatherName && row.dateOfBirth && row.gender && row.city && row.highestQualification && row.totalExperienceYears && row.totalExperienceMonths && row.skills && row.spokenLanguages && row.preferredJobCategories && row.preferredEmploymentTypes && row.preferredWorkTypes && row.street && row.area && row.city && row.pincode && row.fullAddress).length}
                  </div>
                  <div className="text-sm text-gray-600">Complete Records</div>
                </div>
              </Card>
              <Card className="p-4">
                <div className="text-center">
                    <div className="text-2xl font-bold text-orange-600">
                      {parsedData.filter((row: any) => !row.name || !row.email || !row.phone || !row.fatherName || !row.dateOfBirth || !row.gender || !row.city || !row.highestQualification || !row.totalExperienceYears || !row.totalExperienceMonths || !row.skills || !row.spokenLanguages || !row.preferredJobCategories || !row.preferredEmploymentTypes || !row.preferredWorkTypes || !row.street || !row.area || !row.city || !row.pincode || !row.fullAddress).length}
                    </div>
                  <div className="text-sm text-gray-600">Incomplete Records</div>
                </div>
              </Card>
            
            </div>

            {/* Data Table - Same styling as main table */}
            <Card className="mb-6 shadow-lg border-0 rounded-2xl overflow-hidden">
              <CardContent className="p-0">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
                      <tr>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">#</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider sticky left-0 bg-gradient-to-r from-gray-50 to-gray-100 z-10">Name</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Email</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Phone</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Father Name</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">DOB</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Gender</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">City</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Qualification</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Experience</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Skills</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Languages</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Job Categories</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Employment Types</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Work Types</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Street</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Area</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Pincode</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Full Address</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">aadharNumber</th>
                        <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Status</th>
                      </tr>
                    </thead>
                    <tbody className="bg-background divide-y divide-border">
                      {parsedData.map((row: any, index: number) => {
                        const isComplete = row.name && row.email && row.phone && row.fatherName && row.dateOfBirth && row.gender && row.city && row.highestQualification && row.totalExperienceYears && row.totalExperienceMonths && row.skills && row.spokenLanguages && row.preferredJobCategories && row.preferredEmploymentTypes && row.preferredWorkTypes && row.street && row.area && row.city && row.pincode && row.fullAddress;
                        return (
                          <tr key={index} className={`hover:bg-gray-50 transition-colors duration-200 ${isComplete ? 'bg-white' : 'bg-red-50'}`}>
                            <td className="px-4 py-4 text-sm font-medium text-gray-900">{index + 1}</td>
                            <td className={`px-4 py-4 text-sm text-gray-900 font-medium sticky left-0 z-10 border-r border-gray-200 ${isComplete ? 'bg-white' : 'bg-red-50'}`}>{row.name || 'Missing'}</td>
                            <td className="px-4 py-4 text-sm text-gray-900">{row.email || 'Missing'}</td>
                            <td className="px-4 py-4 text-sm text-gray-900">{row.phone || 'Missing'}</td>
                            <td className="px-4 py-4 text-sm text-gray-900">{row.fatherName || 'Missing'}</td>
                            <td className="px-4 py-4 text-sm text-gray-900">{row.dateOfBirth || 'Missing'}</td>
                            <td className="px-4 py-4 text-sm text-gray-900">{row.gender || 'Missing'}</td>
                            <td className="px-4 py-4 text-sm text-gray-900">{row.city || 'Missing'}</td>
                            <td className="px-4 py-4 text-sm text-gray-900">
                              <div className="max-w-xs truncate" title={row.highestQualification}>
                                {row.highestQualification || 'Missing'}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-900">
                              {row.totalExperienceYears || '0'}y {row.totalExperienceMonths || '0'}m
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-900">
                              <div className="max-w-xs truncate" title={row.skills}>
                                {row.skills || 'Not specified'}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-900">
                              <div className="max-w-xs truncate" title={row.spokenLanguages}>
                                {row.spokenLanguages || 'Not specified'}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-900">
                              <div className="max-w-xs truncate" title={row.preferredJobCategories}>
                                {row.preferredJobCategories || 'Not specified'}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-900">
                              <div className="max-w-xs truncate" title={row.preferredEmploymentTypes}>
                                {row.preferredEmploymentTypes || 'Not specified'}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-900">
                              <div className="max-w-xs truncate" title={row.preferredWorkTypes}>
                                {row.preferredWorkTypes || 'Not specified'}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-900">
                              <div className="max-w-xs truncate" title={row.street}>
                                {row.street || 'Not specified'}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-900">
                              <div className="max-w-xs truncate" title={row.area}>
                                {row.area || 'Not specified'}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-900">{row.pincode || 'Not specified'}</td>
                            <td className="px-4 py-4 text-sm text-gray-900">
                              <div className="max-w-xs truncate" title={row.fullAddress}>
                                {row.fullAddress || 'Not specified'}
                              </div>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-900">{row.aadharNumber || 'Not specified'}</td>
                            <td className="px-4 py-4 text-sm">
                              {isComplete ? (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                  <CheckCircle className="h-3 w-3 mr-1" />
                                  Complete
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                  <X className="h-3 w-3 mr-1" />
                                  Incomplete
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </CardContent>
            </Card>

            {/* Warning for incomplete records */}
           {parsedData.filter((row: any) => !row.name || !row.email || !row.phone || !row.fatherName || !row.dateOfBirth || !row.gender || !row.city || !row.highestQualification || !row.totalExperienceYears || !row.totalExperienceMonths || !row.skills || !row.spokenLanguages || !row.preferredJobCategories || !row.preferredEmploymentTypes || !row.preferredWorkTypes || !row.street || !row.area || !row.city || !row.pincode || !row.fullAddress).length > 0 && (
              <Card className="border-orange-200 bg-orange-50">
                <CardContent className="p-4">
                  <div className="flex items-start">  
                    <div className="flex-shrink-0">
                      <X className="h-5 w-5 text-orange-400" />
                    </div>
                    <div className="ml-3">
                      <h3 className="text-sm font-medium text-orange-800">
                        Incomplete Records Found
                      </h3>
                      <div className="mt-2 text-sm text-orange-700">
                        <p>
                          {parsedData.filter((row: any) => !row.name || !row.email || !row.phone || !row.fatherName || !row.dateOfBirth || !row.gender || !row.city || !row.highestQualification || !row.totalExperienceYears || !row.totalExperienceMonths || !row.skills || !row.spokenLanguages || !row.preferredJobCategories || !row.preferredEmploymentTypes || !row.preferredWorkTypes || !row.street || !row.area || !row.city || !row.pincode || !row.fullAddress).length} records are missing.
                          These records will be skipped during upload.
                        </p>
                        <p className="mt-1 text-xs text-orange-600">
                          Note: Fields marked as "(Optional)" in the CSV header are not required and will not cause records to be marked as incomplete.
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      ) : (
        <CandidatesTable
      candidates={candidates}
      setCandidates={setCandidates}
      onCandidateSelect={(candidate) => console.log('Selected candidate:', candidate)}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={handleSort}
      onStatusChange={handleStatusChange}
      candidatesLoading={isLoading}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={handlePageChange}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      onAddCandidate={onAddCandidate}
      user={user}
      pagination={pagination}
      selectedDateFrom={selectedDateFrom}
      setSelectedDateFrom={setSelectedDateFrom}
      selectedDateTo={selectedDateTo}
      setSelectedDateTo={setSelectedDateTo}
      category={category}
      setCategory={setCategory}
      sourcedBy={sourcedBy}
      setSourcedBy={setSourcedBy}
      sourcedByOptions={sourcedByOptions}
      applicationsStatus={applicationsStatus}
      setApplicationsStatus={setApplicationsStatus}
      // Bulk upload props
      showBulkUploadModal={showBulkUploadModal}
      setShowBulkUploadModal={setShowBulkUploadModal}
      handleBulkUpload={handleBulkUpload}
      handleFileUpload={handleFileUpload}
      uploadedFile={uploadedFile}
      setUploadedFile={setUploadedFile}
      // Drag and drop props
      isDragOver={isDragOver}
      setIsDragOver={setIsDragOver}
      handleDragOver={handleDragOver}
      handleDragLeave={handleDragLeave}
      handleDrop={handleDrop}
    />
      )}
    
    </>
  );
}